<template>
  <div class="child-nav search-area">
    <ul class="list">
      <li style="position: relative;">
        <p>
          <input ref="input" class="j-input input-search"
                 type="text" v-model="proname" @input="debounce" @blur="handleBlur"
                 @focus="show = true" @keyup.enter="search" @keydown="handleKeydown">
          <button class="j-btn btn-search" @click="searchPro">検索</button>
        </p>
        <auto-complete :datas="searchlist" v-show="show" :current="current"></auto-complete>
      </li>
      <li>
        <p class="j-btn btn-black">
          <router-link to="/contact">お問い合わせ</router-link>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
  import AutoComplete from './AutoComplete.vue'
  import { search } from '../../service/api'
  export default {
    components: {
      AutoComplete
    },
    data () {
      return {
        proname: '',
        searchlist: [],
        show: false,
        timer: null,
        basePdf: '/static/pdf/',
        current: null
      }
    },
    methods: {
      debounce () {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.autoThink()
        }, 250)
      },
      autoThink() {
        search({name: this.proname})
          .then(({ data, err }) => {
            if (data.status === 200) {
              this.searchlist = data.data.slice(0,10)
              console.log(this.searchlist)
            }
          })
      },
      search() {
        if (this.current !== null && this.searchlist.length) {
          window.open(this.basePdf + this.searchlist[this.current].pdf)
        } else if (this.proname) {
          this.$router.push({ path: `/search/${this.proname}` })
        }
      },
      searchPro() {
        if (this.proname) {
          this.$router.push({ path: `/search/${this.proname}` })
        }
      },
      handleBlur () {
        setTimeout(() => {
          this.show = false
          this.current = null
        }, 500)
      },
      handleKeydown (e) {
        const k = e.keyCode || e.which
        // 40 down, 38 up
        const l = this.searchlist.length
        if (k === 40) {
          this.current = (this.current === null ? 0 : (this.current < l - 1 ? this.current + 1 : this.current))
        } else if (k === 38) {
          this.current = (this.current === 0 ? 0 : this.current - 1)
        }
      }
    },
    watch: {
      '$route' (to, from) {
        // console.log(this.$route.path)
        if (!this.$route.params.proName) {
          this.proname = ''
        }
      }
    }
  }
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss">
  .j-btn.btn-search {
    position: relative;
    background-color: #5e5e5e;
    border: 1px solid #5e5e5e;
    color: #ffffff;
    height: 32px;
    padding: 0 40px;
    letter-spacing: .035rem;
    vertical-align: top;
    border-radius: 0;
    margin-right:75px;
    &::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: 10px;
      bottom: 0;
      width: 30px;
      height: 30px;
      margin: auto;
      background: url('../../assets/icons/search.png') 50% 50% no-repeat;
      background-size: contain;
    }
  }
</style>
<style type="text/scss" rel="stylesheet/scss" lang="scss" x-to="mobile">
  @media screen and (max-width: 767px) {
    .j-header .search-area .list {
      li {
        padding: 10px;
        margin-right: 0;
        display: none;
      }
      li:first-child {
        display: block;
        input {
          font-size: 16px;
          width: 100%;
          background: url('../../assets/icons/search_gray.png') no-repeat;
          background-size: 20px;
          background-color: #ffffff;
          background-position: 5px;
          padding-left: 30px;
        }
        button {
          /*display: none;*/
          width: 25px;
          height: 25px;
          position: absolute;
          top: 0;
          margin-left: -100%;
          opacity: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/SearchArea.vue